import { GoogleMap, Marker, useJsApiLoader } from '@react-google-maps/api';
import PropTypes from 'prop-types';
import React from 'react';
import PinPng from '../../assets/icons/pin-aberto.png';
import { espacamento } from '../../styles/constants/sizes';
import { CampoNude } from '../FormControl/FormControlEstilo';

const Mapa = ({ coordenadas, onClick, totem }) => {
  // Chave do navegador 2 (Google Cloud, na conta "celsinhorock@hotmail.com, em 'Minhas APIs, acesso 'Chaves e credenciais'")
  const { isLoaded } = useJsApiLoader({
    googleMapsApiKey: 'AIzaSyAEHbfn-IChRz1N9vB6mDBwop4aOTUl7f0',
  });

  const containerStyle = {
    width: '100%',
    height: '600px',
  };

  return isLoaded && (
    <CampoNude style={{ marginBottom: espacamento.pequeno }}>
      <GoogleMap
        mapContainerStyle={containerStyle}
        center={coordenadas}
        zoom={16}
        onClick={onClick}
        options={{
          streetViewControl: false,
          mapTypeControl: false,
          fullscreenControl: false,
          styles: [
            {
              featureType: 'poi',
              stylers: [{ visibility: 'off' }],
            },
          ],
        }}
      >
        <Marker
          position={coordenadas}
          icon={PinPng}
        />
      </GoogleMap>
    </CampoNude>
  );
};

Mapa.propTypes = {
  coordenadas: PropTypes.oneOfType([PropTypes.object]),
  onClick: PropTypes.func,
  totem: PropTypes.bool,
};

Mapa.defaultProps = {
  coordenadas: null,
  onClick: null,
  totem: false,
};

export default Mapa;
